import axios from "axios";
import { Constants } from "../utils/Constants";

export function get(slug) {
    return axios.get(`${Constants.baseUrl}/landing-page/${slug}`);
}
